import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import VehicleAcTypeScreen from "../../../container/Vehicles/VehicleAcTypeScreen";
import CreateVehicleAcType from "../../../container/Vehicles/VehicleAcTypeScreen/CreateVehicleAcType";

const VehicleAcTypeRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_ACTYPE.HOME}
          element={<VehicleAcTypeScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.VEHICLE_ACTYPE.CREATE}
          element={<CreateVehicleAcType />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.VEHICLE_ACTYPE.EDIT}
          element={<CreateVehicleAcType isEdit={true} />}
        />
      )}
    </>
  );
};

export default VehicleAcTypeRoutes;
